export const query_autoValutazione_byTenant = `
query getAutovalutazioniByTenant($tenantId: String!, $aziendaId: Int!) {
  autovalutazione(where: {TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId}}, order_by: {Date: desc}) {
    Id
    TenantId
    AziendaId
    TenantTipoId
    Date
    Ri1
    Ri2
    Ri3
    Ri4
    Lv1
    Lv2
    Lv3
    Lv4
    RiTotale
    LvTotale
    RrTotale
    LivelloRischio
    ProvidedBy
    Note
    CreatedOn
    ModifiedOn
    ExpireDate
  }
}`;
export const query_autoValutazione_byTenant_latest = `
query getAutovalutazioneByTenantLatest($tenantId: String!, $aziendaId: Int!) {
  autovalutazione(where: {TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId}}, order_by: {Date: desc}, limit: 1) {
    Id
    TenantId
    AziendaId
    TenantTipoId
    Date
    Ri1
    Ri2
    Ri3
    Ri4
    Lv1
    Lv2
    Lv3
    Lv4
    RiTotale
    LvTotale
    RrTotale
    LivelloRischio
    ProvidedBy
    Note
    CreatedOn
    ModifiedOn
  }
}`;
export const query_autoValutazione_byId = `
query getAutovalutazioneById($id: Int!) {
  autovalutazione_by_pk(Id: $id) {
    Id
    TenantId
    TenantTipoId
    Date
    Ri1
    Ri2
    Ri3
    Ri4
    Lv1
    Lv2
    Lv3
    Lv4
    RiTotale
    LvTotale
    RrTotale
    LivelloRischio
    ProvidedBy
    Note
    CreatedOn
    ModifiedOn
    ExpireDate
  }
}`;
export const query_autoValutazione_byAzienda_count = `
query countAutovalutazioniByAzienda($tenantId: String!, $aziendaId: Int!) {
  autovalutazione_aggregate(where: {TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId}}) {
    aggregate {
      count(columns: Id)
    }
  }
}`;
export const query_autoValutazione_byExpireDate = `
query getAutovalutazioneByExpireDate($tenantId: String!, $aziendaId: Int!,$dtFrom: date!, $dtTo: date!){
  autovalutazione(where: {TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId},
  _and:[
      {ExpireDate: {_gte: $dtFrom}},
      {ExpireDate: {_lte: $dtTo}}
  ]}, order_by: {ExpireDate: desc}){
    Id
    TenantId
    AziendaId
    TenantTipoId
    Date
    Ri1
    Ri2
    Ri3
    Ri4
    Lv1
    Lv2
    Lv3
    Lv4
    RiTotale
    LvTotale
    RrTotale
    LivelloRischio
    ProvidedBy
    Note
    CreatedOn
    ModifiedOn
    ExpireDate
  }
}`;